<template>
  <footer class="pb-10 lg:pb-28">
    <div class="container-1200">
      <div class="border-t-2 border-gray-300 mt-6 lg:mt-28 mb-6 lg:mb-16"></div>
      <div class="flex justify-between items-center gap-8">
        <div class="flex gap-2 items-center">
          <IconsEvangelistIcon />
          <div class="hidden lg:block">
            {{ new Date().getFullYear() }} Evangelist
          </div>
        </div>
        <div class="flex flex-wrap gap-4 lg:gap-8 text-xs lg:text-base">
          <NuxtLink
            data-analytics-click-id="button_privacy_policy_clicked"
            class="hover:underline"
            to="/articles/privacy-policy"
            >Privacy Policy</NuxtLink
          >
          <NuxtLink
            data-analytics-click-ida="button_terms_of_service_clicked"
            class="hover:underline"
            to="/articles/terms"
            >Terms and Conditions</NuxtLink
          >
        </div>
      </div>
    </div>
  </footer>
</template>
